
















import BaseComponent from '@/components/base-component.vue';
import * as service from '@/services/users';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class UiAutocompleteSubordinate extends BaseComponent {
  @Prop()
  value: any;

  @Prop()
  defaultItems: any[];

  @Prop({ default: true })
  returnText: boolean;

  @Prop({ default: true })
  useIdLogin: boolean;

  @Prop()
  disabled: any;
  
  @Prop()
  readonly: any;

  selected: any = null;
  searchInput = null;

  loading = false;
  list = [];

  @Watch('value', { immediate: true })
  onValueChange(v) {
    this.selected = v;
  }

  @Watch('defaultItems', { immediate: true })
  onDefaultItemsChange(v) {
    this.addDefaultItems();
  }

  mounted() {
    this.load();
  }

  load() {
    return service.listSubordinates(true, true).subscribe(
      (res) => {
        this.list = res;
        this.loading = false;
        this.addDefaultItems();
      },
      (error) => {
        this.showToastApiError(error);
        this.loading = false;
      }
    );
  }

  onChange() {
    this.$emit('input', this.selected);
    this.$emit('change', this.selected);
  }

  addDefaultItems() {
    if (!this.defaultItems || !this.defaultItems.length) {
      return;
    }

    if (!this.list) {
      this.list = new Array();
    }

    this.defaultItems.forEach((i) => {
      if (!this.list.find((il) => this.useIdLogin ? il.idLogin == i.id : il.id == i.id)) {
        this.list.push(i);
      }
    });
    this.list = this.list.sort((o1, o2) => (o1.nome < o2.nome ? -1 : o1.nome == o2.nome ? 0 : 1));
  }
}
